export enum ReturnPolicyStoreCreditType {
  GiftCard = "gift_card",
  DiscountCode = "discount_code",
  Rise = "rise",
  Loopz = "loopz",
  Creditsyard = "creditsyard",
  Bubblehouse = "bubblehouse",
  ShopifyAccount = "shopify_account",
  GiftCardOrder = "gift_card_order",
  Noop = "noop",
}
